import React, { useState,useEffect } from "react";
import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import { Tooltip } from 'react-tooltip';
import { NoAuthApiRequest,ApiRequest } from "./services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";// //"./utils/endpoints";
import { useNavigate } from "react-router";
import  Loader from './shared/loader';
import { toast } from "react-toastify";

const TeamUsers = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [loader,setloader]=useState(false);
    const navigate = useNavigate();
    const [lstLead, setlstLead] = useState([]);
    const [Index,setIndex]=useState(-1);
    const [leadName,setleadName]=useState('');
    const [search,setsearch]=useState('');

    const [users, setUsers] = useState([]);

    const [assignUsers, setAssignUsers] = useState([]);
        const [searchalluser,setsearchalluser]=useState('');
        const [searchassigneduser,setsearchassigneduser]=useState('');

    const filteredUsers = users.filter(user => user.Name.toLowerCase().includes(searchalluser.toLowerCase()));
    const filteredAssignedUsers = assignUsers.filter(user => user.Name.toLowerCase().includes(searchassigneduser.toLowerCase()));


          useEffect(() => {
            
                    const fetchData = async () => {
                       await fetchLeadList();
                    };
                    fetchData();
            
                },[]);
    
                const handleKeyPress = async (event) => {
                    // Check if the pressed key is Enter (keyCode 13)
                    if (event.key === 'Enter') {
                        await fetchLeadList();
                      // You can trigger any logic here when Enter is pressed
                    }
                  };
                
                  const handleChanges = (event) => {
                    setsearch(event.target.value);
                  };

        const fetchLeadList = async()=>{
                setloader(true);
                const data = await ApiRequest(ApiEndpoints.User.FetchLeadUserswithSearch(search), ApiEndpointMethod.Get, null, navigate);
                    if(data != null){
                        setlstLead(data);
                        setIndex(-1);
                    }
                    setloader(false);
        }

            const FetchLeadUserMapping = async(LeadId)=>{
                setloader(true);
                const data = await ApiRequest(ApiEndpoints.User.FetchLeadUserMapping(LeadId), ApiEndpointMethod.Post, null, navigate);
                if(data != null){
                
              
                    setUsers(data.Item1)
                    setAssignUsers(data.Item2);
                }
                setloader(false);
            }

            
    const moveValue = async(Id,type)=>{
      
        if(type=="User"){
        var filtervalue =  users.filter(x=>x.Id==Id);
        if(filtervalue != null && filtervalue.length>0){
            var lstusers=[];
            lstusers = users.filter(x=>x.Id!=Id);
            // users.forEach((item) => {
            //     lstusers.push(item);
            // });
            
            // filtervalue.forEach((item) => {
            //     lstusers.pop(item);
            // });
          
            lstusers.sort((a, b) => a.Name.localeCompare(b.Name));
            setUsers(lstusers);

            var lstassignoption =[];
            assignUsers.forEach((item) => {
                lstassignoption.push(item);
            });
            filtervalue.forEach((item) => {
                lstassignoption.push(item);
            });
            
            lstassignoption.sort((a, b) => a.Name.localeCompare(b.Name));
            setAssignUsers(lstassignoption);
        }
        }
        else if(type=="MapUser"){
            var filtervalue =  assignUsers.filter(x=>x.Id==Id);
            if(filtervalue != null){

                var lstassignoption=[];
                lstassignoption = assignUsers.filter(x=>x.Id!=Id);
                lstassignoption = lstassignoption.sort(x=>x.Name);
                lstassignoption.sort((a, b) => b.Name.localeCompare(a.Name));
                setAssignUsers(lstassignoption);


            var lstusers=[];
            users.forEach((item) => {
                lstusers.push(item);
            });
            filtervalue.forEach((item) => {
                lstusers.push(item);
            });
           // lstusers = lstusers.sort(x=>x.Name);
            lstusers.sort((a, b) => a.Name.localeCompare(b.Name));
            setUsers(lstusers);
            }
        }

    }

        const SaveLeadUserMapping = async()=>{
    
            setloader(true);
           var leadId =  lstLead[Index].Id
            const data = await ApiRequest(ApiEndpoints.User.LeadUserMapping(leadId), ApiEndpointMethod.Post, assignUsers, navigate);
            if(data != null){
            
                 toast.success("Information stored successfully", {
                                                        position: "top-right",
                                                        autoClose: 3000,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                        theme: "light",
                                                    });
                                                    var indexsvalue =Index;

               await fetchLeadList();
               await setIndex(indexsvalue);
             
                // setUsers(data.Item1)
                // setAssignUsers(data.Item2);
            }
         
            
        }

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="row">
                            <div className="col-lg-4 border-end border-lite">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Team Users</h5>
                                    <input className="form-control" placeholder="search..." 
                                    onChange={handleChanges}  onKeyDown={handleKeyPress} value={search} 
                                    type="search" style={{ width: '180px' }} />
                                </div>
                                <div className="list-group list-group-start">
                                 {lstLead?.map((lead,ind) => (
                                    <div onClick={()=>{setIndex(ind);setleadName(lead.Name); FetchLeadUserMapping(lead.Id)}} className={`list-group-item d-flex justify-content-between align-items-center ${ind  === Index ? 'active' : ''}`}>
                                        <p className="mb-0">{lead.Name}</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">{lead.UserCount} Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div>
                                      ))}
                                    {/* <div className="list-group-item d-flex justify-content-between align-items-center active">
                                        <p className="mb-0">Harini Swamy</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">3 Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex justify-content-between align-items-center">
                                        <p className="mb-0">Rachel</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">5 Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex justify-content-between align-items-center">
                                        <p className="mb-0">Muruga Sundaram</p>
                                        <div>
                                            <span className="badge rounded-pill text-bg-success shadow-sm px-3 me-2">2 Users</span>
                                            <a className="text-primary" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                        </div>
                                    </div> */}
                                </div>
                            </div>

                            <div className="col-lg-8">
                            {Index==-1 &&(
                                <div className="row">

                                </div>
                                   )}
                            {Index>-1 &&(
                                <div className="row">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0 text-muted">{leadName}</h5>
                                    <button type="button" className="btn btn-sm btn-info"  onClick={() => SaveLeadUserMapping()}>
                                        <i className="fas fa-check me-2"></i>Save
                                    </button>
                                </div>

                                <div className="mb-2 text-muted hide" style={{display:"none"}}>
                                    <i className="fas fa-info-circle me-1 text-primary fs-f8"></i>
                                    Drag and drop users to assign them to projects
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">All Users</div>
                                            <div className="card-body p-0">
                                               <input type="text" className="form-control" name="searchalluser" 
                                                onChange={(e) =>
                                                    setsearchalluser(
                                                      e.target.value
                                                    )
                                                  }
                                                 placeholder="Search"/>
                                                <ul className="draggable-list">
                                                 {filteredUsers.map((user) => (
                                                        <li value={user.Id}>
                                                           <label style={{width:"90%"}}>{user.Name}</label>
                                                           <i className="fas fa-arrow-circle-right" style={{cursor:"pointer"}} onClick={()=>{moveValue(user.Id,'User')}} ></i>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="card rounded-0">
                                            <div className="card-header">Assigned Users</div>
                                            <div className="card-body p-0">
                                            <input type="text" className="form-control" name="searchalluser" 
                                                onChange={(e) =>
                                                    setsearchassigneduser(
                                                      e.target.value
                                                    )
                                                  }
                                                 placeholder="Search"/>
                                                <ul className="draggable-list">
                                                {filteredAssignedUsers.map((user, index) => (
                                                        <li className="d-flex justify-content-between align-items-center" value={user.Id}>
                                                          <i className="fas fa-arrow-circle-left" style={{cursor:"pointer"}} onClick={()=>{moveValue(user.Id,'MapUser')}} ></i>
                                                           <label style={{width:"90%"}}>{user.Name}</label>
                                                            {/* <a className="text-danger fs-f8" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                                <i className="fas fa-trash-alt"></i>
                                                            </a> */}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                             )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            
 {loader && (
                <Loader/>
            )}
        </>
    )
}

export default TeamUsers;